import * as swcHelpers from '@swc/helpers';
import { DataLayer } from '@grandvisionhq/analytics';
import { getSharedProductDetailEventTrackingAttributes, getVariantSpecification } from './get-shared-product-detail-event-tracking-attributes.js';

const getJoinedValues = (values)=>{
    return (values === null || values === void 0 ? void 0 : values.join(', ').toLowerCase()) || '';
};
const getAccessoriesEventAttributes = (sharedAttributes, masterSku, activeVariant)=>swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.Accessories,
        brand: getVariantSpecification([
            'brand'
        ], activeVariant),
        variant: getVariantSpecification([
            'accessoryTypeUnlocalized',
            'accessoryType'
        ], activeVariant),
        dimension16: getVariantSpecification([
            'genderUnlocalized',
            'gender'
        ], activeVariant),
        dimension146: getVariantSpecification([
            'materialUnlocalized',
            'material'
        ], activeVariant),
        dimension147: getVariantSpecification([
            'accessoryColorUnlocalized',
            'accessoryColor'
        ], activeVariant),
        dimension140: masterSku
    })
;
const getSunglassesEventAttributes = (sharedAttributes, masterSku, activeVariant)=>{
    return swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.Sunglasses,
        brand: getVariantSpecification([
            'brand'
        ], activeVariant),
        variant: getVariantSpecification([
            'frameShapeUnlocalized',
            'frameShape'
        ], activeVariant),
        dimension16: getVariantSpecification([
            'genderUnlocalized',
            'gender'
        ], activeVariant),
        dimension140: masterSku,
        dimension146: getVariantSpecification([
            'frameMaterialUnlocalized',
            'frameMaterial'
        ], activeVariant),
        dimension147: getVariantSpecification([
            'frameColorUnlocalized',
            'frameColor'
        ], activeVariant),
        dimension191: getVariantSpecification([
            'frameTypeUnlocalized',
            'frameType'
        ], activeVariant),
        dimension192: getJoinedValues(activeVariant.faceShapes)
    });
};
const getFramesEventAttributes = (sharedAttributes, masterSku, activeVariant)=>{
    var ref, ref1;
    return swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.Optical,
        brand: getVariantSpecification([
            'brand'
        ], activeVariant),
        variant: getVariantSpecification([
            'frameShapeUnlocalized',
            'frameShape'
        ], activeVariant),
        dimension16: getVariantSpecification([
            'genderUnlocalized',
            'gender'
        ], activeVariant),
        dimension140: masterSku,
        dimension146: (ref = getVariantSpecification([
            'frameMaterialUnlocalized',
            'frameMaterial'
        ], activeVariant)) !== null && ref !== void 0 ? ref : '',
        dimension147: (ref1 = getVariantSpecification([
            'frameColorUnlocalized',
            'frameColor'
        ], activeVariant)) !== null && ref1 !== void 0 ? ref1 : '',
        dimension191: getVariantSpecification([
            'frameTypeUnlocalized',
            'frameType'
        ], activeVariant),
        dimension192: getJoinedValues(activeVariant.faceShapes)
    });
};
const getContactLensesEventAttributes = (sharedAttributes, masterSku, activeVariant)=>{
    return swcHelpers.objectSpread({}, sharedAttributes, {
        brand: getVariantSpecification([
            'brand'
        ], activeVariant),
        category: DataLayer.DataLayerTypes.Category.ContactLenses,
        variant: getVariantSpecification([
            'lensTypeUnlocalized',
            'lensType'
        ], activeVariant),
        dimension140: masterSku,
        dimension148: getVariantSpecification([
            'replacementFrequencyUnlocalized',
            'replacementFrequency'
        ], activeVariant),
        dimension146: getVariantSpecification([
            'materialUnlocalized',
            'material'
        ], activeVariant)
    });
};
const getProductDetailEventTrackingAttributes = (props)=>{
    const { masterSku , activeVariant  } = props;
    const sharedAttributes = getSharedProductDetailEventTrackingAttributes(props);
    switch(activeVariant.variantType){
        case 'sunglasses':
            return getSunglassesEventAttributes(sharedAttributes, masterSku, activeVariant);
        case 'accessories':
            return getAccessoriesEventAttributes(sharedAttributes, masterSku, activeVariant);
        case 'frames':
            return getFramesEventAttributes(sharedAttributes, masterSku, activeVariant);
        case 'contact-lens':
            return getContactLensesEventAttributes(sharedAttributes, masterSku, activeVariant);
        default:
            /**
       * TODO: Add other product types after they have been migrated to PDP V2
       * Migration progress reference: https://confluence.grandvision.global/pages/viewpage.action?spaceKey=GV&title=PDP+v2+migration+status
       */ return undefined;
    }
};

export { getProductDetailEventTrackingAttributes };
//# sourceMappingURL=get-product-detail-event-tracking-attributes.js.map
